import Vpc from '../svgs/vpc.svg';
import Routing from '../svgs/routing.svg';
import Firewall from '../svgs/firewall.svg';

export const networkingList = [
  {
    subtitle: 'benefits.fastAndEasy.title',
    subdescription: 'benefits.fastAndEasy.description'
  },
  {
    subtitle: 'benefits.control.title',
    subdescription: 'benefits.control.description'
  },
  {
    subtitle: 'benefits.safety.title',
    subdescription: 'benefits.safety.description'
  },
  {
    subtitle: 'benefits.setting.title',
    subdescription: 'benefits.setting.description'
  },
  {
    subtitle: 'benefits.scalability.title',
    subdescription: 'benefits.scalability.description'
  },
  {
    subtitle: 'benefits.nonStopWork.title',
    subdescription: 'benefits.nonStopWork.description'
  }
];

export const toDoNetworkingList = [
  {
    subtitle: 'toDoNetworking.vpcNetworks.title',
    subdescription: 'toDoNetworking.vpcNetworks.description',
    img: Vpc,
    value: 'workWithNetworking.imgName.networking'
  },
  {
    subtitle: 'toDoNetworking.vpcRouting.title',
    subdescription: 'toDoNetworking.vpcRouting.description',
    img: Routing,
    value: 'workWithNetworking.imgName.routing'
  },
  {
    subtitle: 'toDoNetworking.vpcFirewall.title',
    subdescription: 'toDoNetworking.vpcFirewall.description',
    subdescriptionSecond: 'toDoNetworking.vpcFirewall.descriptionSecond',
    img: Firewall,
    value: 'workWithNetworking.imgName.firewall'
  }
];
